import { Flow } from 'signup-constants/Flow';
import { Integration } from 'signup-constants/Integration';
import { isFlow } from '../utils/isFlow';
import { isIntegration } from '../utils/isIntegration';
import { isExistingUserExistingAccount } from '../app/verificationTypeSelectors';
import { getHasRefreshedNewPortalAuth, getIsNewPortalCreated, getIsNewUser } from '../store/app/selectors';
import { isPortalIdDefined } from '../store/auth/selectors';
import { getCurrentStep, isEndOfFlow } from '../store/flow/selectors';
import { getIsWordPressAuthFinished } from '../store/integrations/selectors';
import { hasAnsweredAllPostExistingAccountSelectedQuestions } from '../store/signup-data/selectors';
import { Intent } from 'signup-constants/Intent';
import { isIntent } from '../utils/isIntent';
import { isEndpointStatusSuccess } from '../store/http-responses/selectors';
import { EndpointKey } from '../http/EndpointKey';
export const canInstallFallbackTimer = state => {
  const portalIdDefined = isPortalIdDefined(state);
  const isNewPortalCreated = getIsNewPortalCreated(state);
  const currentStep = getCurrentStep(state);
  const hasRefreshedNewPortalAuth = getHasRefreshedNewPortalAuth(state);
  const endOfFlow = isEndOfFlow(state);
  const isWPAuthFinished = getIsWordPressAuthFinished(state);
  const isNewUser = getIsNewUser(state);
  const haveScopesBeenGrantedForBlogIdeasGenerator = isEndpointStatusSuccess(EndpointKey.CheckScopesForBlogIdeasGeneratorNewUser)(state);

  if (isIntent(Intent.blogIdeasGenerator) && isNewUser && !haveScopesBeenGrantedForBlogIdeasGenerator) {
    return false;
  }

  if (isIntegration(Integration.Wordpress) && !isWPAuthFinished) {
    return false;
  }

  if (isExistingUserExistingAccount(state) && !isFlow(Flow.StandaloneCmsPartner)) {
    return endOfFlow && portalIdDefined && hasAnsweredAllPostExistingAccountSelectedQuestions(state);
  }

  return endOfFlow && hasRefreshedNewPortalAuth && !currentStep && isNewPortalCreated && portalIdDefined;
};